import React from 'react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  return (
    <main className="pt-20">
      <Gallery />
    </main>
  );
};

export default GalleryPage; 